import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './app.scss';
// import reportWebVitals from './reportWebVitals';
// import TagManager from 'react-gtm-module';

// const tagManagerArgs = {
//     gtmId: 'GTM-PHDDNGF'
// }
// TagManager.initialize(tagManagerArgs);

// const tagManagerArgs2 = {
//     gtmId: 'GTM-NCGSD7F'
// }
// TagManager.initialize(tagManagerArgs2);

const root = ReactDOM.createRoot(document.getElementById('root_skoda_trade_in'));
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
